import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { useNavigate, useParams } from "react-router-dom";
import { formregdetail, schformdetail } from "../../../../services/superadmin";
import moment from "moment";
import { Modal } from "react-bootstrap";

export const FormDetail = () => {
    const { id, eid } = useParams();
    const [fname, setFName] = useState("");
    const navigate = useNavigate();
    const [fdetail, setFDetail] = useState("");
    const [s3path, setS3Path] = useState("");
    const [file, setFile] = useState(false);
    const [fhead, setFHead] = useState(false);
    const [alist, setAList] = useState([]);
    const [rlist, setRList] = useState([]);

    const [ishow, setImage] = useState(false);
    useEffect(() => {
        schformdetail(id).then((res) => {
            if (res.status === true) {
                setFName(res.data.scholarship_form.form_name);
            }
        })
        formregdetail(id, eid).then((res) => {
            if (res.status === true) {
                console.log(res)
                setFDetail(res.data.data.form_data)
                setS3Path(res.data.data.s3path)
                setAList(res.data.data.achievements)
                setRList(res.data.data.references)
            }
        })
    }, []);


    function backlist() {
        dotracking("back button in registered form detail for " + fname + " (" + id + ") $$ " + trackobj.formlistheading);
        
        if(localStorage.getItem("Role") === '8'){
            navigate("/funder/formregisterlist/" + id)
        }else if(localStorage.getItem("Role") === '3'){
            navigate("/cityregional/formregisterlist/" + id)
        }else{
           navigate("/superadmin/formregisterlist/" + id)
        }
    }

    function ImageShow(ifile, ihead) {
        setFHead(ihead)
        setFile(ifile);
        setImage(true);
    }
    function ImageClose() {
        setImage(false);
    }

    function downloadImage() {
        const link = document.createElement('a');
        link.href = file;
        link.download = fhead.replace(/\s+/g, '_') + '_' + new Date().getTime();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function errorhandle(ev) {
        ev.target.src = require("../../../../assets/images/users.png");
        ev.target.onerror = null;
    }
    return (
        <div className="side-app">
            <div className="page-header">
                <div className="breadcrumb">
                    <h4 className="mb-0">Registered Form Detail</h4>
                </div>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Scholarship Form</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Registered Form Detail
                    </li>
                </ol>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="text-end">
                        <a className="btn btn-gray me-2" onClick={backlist}>
                            <i className="fe fe-corner-up-left"></i> Back
                        </a>
                    </div>
                    <form className="card mt-2">

                        <div className="card-header">
                            <h3>{fname}</h3>

                        </div>
                        <div className="card-body">
                            <div className="card-body">
                                <h4>Personel Details</h4>
                                <div className="row tournamentitem">
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Name</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Date of Birth</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail ? moment(fdetail.dob).format("DD-MM-YYYY") : ''}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Gender</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.gender}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Permanent Address</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.permanent_address}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Communication Address</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.communication_address}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Mobile Number</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.mobile_number}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Email ID</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.email_id}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Highest Educational Qualification</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.highest_educational_qualification}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Height</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.height}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Weight</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.weight}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Medical Condition</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.medical_condition}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h4>Sports Details</h4>


                                <div className="row tournamentitem">
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Sport Name</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.sport_name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Coach Name</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.coach_name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Coach Mobile Number</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.coach_mobile_number}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Coach Email ID</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.coach_email_id}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Coach Designation</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.coach_designation}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Coach Qualification</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.coach_qualification}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Coach Training Base</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.coach_training_base}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <h4>Family Details</h4>
                                <div className="row tournamentitem">
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Father Name</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.father_name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Father Occupation</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.father_occupation}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Mother Name</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.mother_name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">Family Annual Income</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.family_annual_income}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="details-group">
                                            <div className="row">
                                                <div className="col-lg-4 col-md-6">
                                                    <b className="text-inverse">How Did You Know About Application</b>
                                                </div>
                                                <div className="col-md-8 col-md-6">
                                                    <span className="text-inverse">{fdetail?.how_did_you_know_application}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {fdetail?.how_did_you_know_application == "Other" &&
                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Other Source</b>
                                                    </div>
                                                    <div className="col-md-8 col-md-6">
                                                        <span className="text-inverse">{fdetail?.other_source}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <hr />
                                <h4>Achievements</h4>
                                {alist.map((item, i) => (
                                    <div className="row tournamentitem" key={i}>
                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Competition Type</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.competition_type}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Event Type</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.event_name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Competition Name</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.competition_name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Date</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">
                                                            {item.date_of_competition ? moment(item.date_of_competition).format("DD-MM-YYYY") : ''}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Position / Rank</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.position_or_rank}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Time / Score / Distance</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.time_score_distance}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <h4>Certificate</h4>
                                            <div className="link-btn">
                                                {item.achievement_certificate &&
                                                    item.achievement_certificate.toLowerCase().endsWith(".pdf") ? (
                                                    // PDF View
                                                    <a
                                                        href={s3path + item.achievement_certificate}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <img
                                                            src={require("../../../../assets/images/pdf.png")}
                                                            alt="PDF Certificate"
                                                            height="160"
                                                        // onClick={() =>
                                                        //     ImageShow(s3path + item.achievement_certificate, "Certificate")
                                                        // }
                                                        />
                                                    </a>
                                                ) : (
                                                    // Image View
                                                    <a>
                                                        <img
                                                            className="profile_img"
                                                            src={s3path + item.achievement_certificate}
                                                            height="160"
                                                            alt="Certificate"
                                                            onClick={() =>
                                                                ImageShow(s3path + item.achievement_certificate, "Certificate")
                                                            }
                                                            onError={(e) => errorhandle(e)}
                                                        />
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                        <hr />
                                    </div>
                                ))}
                                <h4>References</h4>
                                {rlist.map((item, i) => (
                                    <div className="row tournamentitem" key={i}>
                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Reference Name</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.reference_name}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Designation</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.reference_designation}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Mobile Number</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">
                                                            {item.reference_mobile_no}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="details-group">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6">
                                                        <b className="text-inverse">Email</b>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <span className="text-inverse">{item.reference_email_id}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr />
                                    </div>
                                ))}

                                {/* <div className="row tournamentitem">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <h4>Family Income Proof</h4>

                                                <div className="link-btn">
                                                    <a>
                                                        <img
                                                            className="profile_img"
                                                            src={s3path + fdetail.proof_of_family_income}
                                                            height="160"
                                                            alt="photo"
                                                            onClick={(e) => ImageShow(s3path + fdetail.proof_of_family_income, 'Family Income Proof')}
                                                            onError={(e) => errorhandle(e)}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <hr /> */}
                                <h4>Documents</h4>

                                <div className="row tournamentitem">
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <h4>Photograph</h4>
                                                <div className="link-btn">
                                                    <a>
                                                        <img
                                                            className="profile_img"
                                                            src={s3path + fdetail.photograph}
                                                            height="160"
                                                            alt="photo"
                                                            onClick={(e) => ImageShow(s3path + fdetail.photograph, 'Photograph')}
                                                            onError={(e) => errorhandle(e)}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <h4>ID Proof</h4>
                                                <div className="link-btn">
                                                    <a>
                                                        <img
                                                            className="profile_img"
                                                            src={s3path + fdetail.id_proof}
                                                            height="160"
                                                            alt="photo"
                                                            onClick={(e) => ImageShow(s3path + fdetail.id_proof, 'ID Proof')}
                                                            onError={(e) => errorhandle(e)}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <h4>Bank Passbook</h4>
                                                <div className="link-btn">
                                                    <a>
                                                        <img
                                                            className="profile_img"
                                                            src={s3path + fdetail.bank_passbook_first_page}
                                                            height="160"
                                                            alt="photo"
                                                            onClick={(e) => ImageShow(s3path + fdetail.bank_passbook_first_page, 'Bank Passbook')}
                                                            onError={(e) => errorhandle(e)}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <h4>Playing Sport Photo</h4>
                                                <div className="link-btn">
                                                    <a>
                                                        <img
                                                            className="profile_img"
                                                            src={s3path + fdetail.photo_of_playing_sport}
                                                            height="160"
                                                            alt="photo"
                                                            onClick={(e) => ImageShow(s3path + fdetail.photo_of_playing_sport, 'Playing Sport Photo')}
                                                            onError={(e) => errorhandle(e)}
                                                        />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <Modal show={ishow} onHide={ImageClose}>
                                <Modal.Header>
                                    <h4>{fhead}</h4>
                                </Modal.Header>
                                <Modal.Body>
                                    <img
                                        className="profile_img prof-img"
                                        src={file}
                                        // height="160"
                                        alt="photo"
                                        onError={(e) => errorhandle(e)}
                                    />
                                </Modal.Body>
                                <Modal.Footer>
                                    {localStorage.getItem("Role") === "1" &&
                                        <a
                                            className="btn btn-next btn-success text-right"
                                            onClick={downloadImage}
                                        >
                                            Download
                                        </a>
                                    }

                                    <a
                                        className="btn btn-next btn-secondary text-right"
                                        onClick={ImageClose}
                                    >
                                        Close
                                    </a>
                                </Modal.Footer>
                            </Modal>
                        </div>

                    </form>
                </div>
            </div >
        </div >


    );
};
